import ErrorBoundary from 'ErrorBoundary';
import './App.css';
import { UserContextProvider } from 'context';
import Router from 'router/Router';
import { useNetworkStatus } from 'hooks';
import { Toaster } from 'react-hot-toast';

function App() {
  const isOnline = useNetworkStatus();
  return (
    <ErrorBoundary>
      <Toaster />
      <UserContextProvider>
        <Router />
      </UserContextProvider>
      {!isOnline && (<div style={{ position: 'absolute', zIndex: 1000, bottom: 0, background: 'red', color: '#fff', width: '100%', textAlign: 'center' }}>
        <p>You are offline. Please check your internet connection.</p>
      </div>)}
    </ErrorBoundary>
  );
}

export default App;
